import { oLilyPad } from "./oLilyPad.js";

export var oLilyPad1 = InheritO(oLilyPad, {
	EName: "oLilyPad1",
});
